import React from 'react'

import { ReactComponent as GoogleIcon } from './google_g_logo.svg'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
// material
import { Box, Divider, Typography } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import { getMcpAuthorizeReturnUrl } from 'src/utils/mcp-oauth-handoff'
// ----------------------------------------------------------------------
export default function AuthFirebaseSocials() {
  // When signing in as part of the MCP connector OAuth flow, propagate the gateway
  // `returnUrl` so the backend can resume /authorize after the external login.
  const mcpReturnUrl = getMcpAuthorizeReturnUrl()
  const externalLoginUrl = provider => {
    const base = `${process.env.REACT_APP_URL}externalauth/externalLogin?provider=${provider}`
    return mcpReturnUrl
      ? `${base}&returnUrl=${encodeURIComponent(mcpReturnUrl)}`
      : base
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
        <Box
          component="a"
          href={externalLoginUrl('Google')}
          sx={{
            flex: '1 0 0',
            height: '48px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '10px',
            border: '1px solid rgba(145, 158, 171, 0.32)',
            background: '#FFF',
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': { background: '#F4F6F8' },
          }}
        >
          <GoogleIcon />
        </Box>

        {/* <Box
          component="a"
          href={externalLoginUrl('LinkedIn')}
          sx={{
            flex: '1 0 0',
            height: '48px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '10px',
            border: '1px solid rgba(145, 158, 171, 0.32)',
            background: '#FFF',
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': { background: '#F4F6F8' },
          }}
        >
          <LinkedInIcon style={{ color: '#0A66C2' }} />
        </Box> */}
      </Box>

      <Divider sx={{ my: 2 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          OR
        </Typography>
      </Divider>
    </>
  )
}
